// Данните от иконата до „ЕИК" (`GET /customers/lookup`) заменят ЦЯЛАТА фирма
// във формата: поле, което търсенето не върне, става празно — не остава от
// предишната фирма (иначе документът смесва данните на две фирми). Ползват го
// издаването на фактура и „Конфигурация → Фирми".

import type { CustomerLookupResult } from "../api/customers";

export interface EikLookupFields {
  companyName: string;
  vatNumber: string;
  city: string;
  address: string;
  mol: string;
}

export const eikLookupFieldsOf = (found: CustomerLookupResult): EikLookupFields => ({
  companyName: found.company_name,
  vatNumber: found.vat_number ?? "",
  city: found.city ?? "",
  address: found.address ?? "",
  mol: found.mol ?? "",
});

/** Фирмата (издателят) няма поле за град — градът застава пред адреса. */
export const addressWithCity = ({ city, address }: Pick<EikLookupFields, "city" | "address">): string =>
  [city, address].filter(Boolean).join(", ");
